/**
 * Touch input — virtual joystick + button taps. Populated by
 * MobileControls; the World move loop reads it whenever active is true
 * (overrides keyboard). Keep in zustand so UI components and the render
 * loop share the same state without prop-drilling.
 */

import { create } from 'zustand';

interface TouchInputStore {
  /** Whether touch controls are active this frame. */
  active: boolean;
  /** Joystick offset in [-1, 1]. */
  moveX: number;
  moveY: number;
  /** Player is sprinting (e.g. joystick deflection > 0.95). */
  running: boolean;
  setMove: (x: number, y: number) => void;
  setActive: (b: boolean) => void;
}

export const useTouchInput = create<TouchInputStore>((set) => ({
  active: false,
  moveX: 0,
  moveY: 0,
  running: false,
  setMove: (x, y) => {
    const len = Math.hypot(x, y);
    set({ moveX: x, moveY: y, running: len > 0.95 });
  },
  setActive: (b) => set({ active: b, ...(b ? {} : { moveX: 0, moveY: 0, running: false }) }),
}));
